import React, { useEffect } from 'react';
import { Stack } from '@mantine/core';
import EventLoading from '../EventLoading';
import { EventHeading } from '../EventHeadings/EventHeading';
import { DeliveryUpcomingCapacity } from './DeliveryUpcoming.capacity';
import { DeliveryUpcomingManifests } from './DeliveryUpcoming.manifests';
import { DeliveryUpcomingOrders } from './DeliveryUpcoming.orders';
import { EventDetails } from '../shared/Event.details';
import { deliveryDownloadConfig } from './config';
import { EventDownload } from '../shared/Event.download';
import { getRestaurantInfo } from '../helpers';
import { useDeliveryUpcomingEvent } from './useDeliveryUpcomingEvent';
import useTrackEvent from '../useTrackEvent';
import dayjs from 'dayjs';

export const DeliveryUpcoming: React.FC<{ id: string; onCloseWithoutEvent: () => void }> = ({
  id,
  onCloseWithoutEvent,
}) => {
  const { event, itemCount, loading } = useDeliveryUpcomingEvent(id);

  useTrackEvent(event);

  useEffect(() => {
    if (!loading && !event) {
      onCloseWithoutEvent();
    }
  }, [loading, event, onCloseWithoutEvent]);

  if (loading) {
    return <EventLoading />;
  }

  if (!event) {
    return <></>;
  }

  const eventTitle = `${event.productType.toLowerCase()} Event Details`;
  const eventDetails = {
    manifestTime: event.selectEvent.startTime,
    readyAndBaggedTime: event.selectEvent.readyAndBaggedTime,
    restaurant: getRestaurantInfo(event.vendor?.internalName, event.vendor?.address),
    placeName: event.selectEvent.account.name,
  };

  const showOrderPreview = !!event.selectEvent.startTime &&
    dayjs().isAfter(dayjs(event.selectEvent.startTime).subtract(24, 'hour'));

  const eventDownloadDetails = {
    ...deliveryDownloadConfig,
    leftDownloadUrl: event.preManifestDocument?.documentUrl || '',
    rightDownloadUrl: event.finalManifestDocument?.documentUrl || '',
  };

  return (
    <EventHeading eventStartTime={event.selectEvent.startTime} title={eventTitle}>
      <Stack gap="md">
        <EventDetails eventDetails={eventDetails} />
        <DeliveryUpcomingManifests event={event} />
        {showOrderPreview && (
          <DeliveryUpcomingOrders
            summaryItemCount={itemCount}
            orderingWindowEndTimeUtc={event.selectEvent.startTime}
            vendorId={event.vendor.id}
          />
        )}
        <DeliveryUpcomingCapacity event={event} />
        <EventDownload eventDownloadDetails={eventDownloadDetails} />
      </Stack>
    </EventHeading>
  );
};
